/**
 * Company details referenced by legal docs (content is also inlined in markdown).
 */
export const LEGAL_COMPANY_NAME = 'ShopQuay Limited'
export const LEGAL_CONTACT_EMAIL = 'hello@shopquay.com'
export const LEGAL_COMPANY_ADDRESS =
  'Flat C, 2/F, Wong King Industrial Building, 192-198 Choi Hung Road, San Po Kong, Kowloon, Hong Kong'
export const LEGAL_LAST_UPDATED = '26 July 2026'
/** Nominal liability ceiling for free/trial accounts (not a fee). */
export const LEGAL_TRIAL_LIABILITY_CAP_HKD = 'HKD 780'

/** Public marketing / support contacts (shopquay.com footer). */
export const PLATFORM_FACEBOOK_URL =
  'https://www.facebook.com/profile.php?id=61593277946237'
/** Hong Kong number from platform shop phone (852 + 60439832). */
export const PLATFORM_WHATSAPP_URL = 'https://wa.me/85260439832'
